import { get, isNull } from "lodash";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import { endOfDay, format, getQuarter, startOfMonth, parse, isValid } from "date-fns";
import ruLocale from "date-fns/locale/ru";

export const formatDateFromServer = (dateFromServer) => {
  return dateFromServer ? new Date(dateFromServer) : null;
};

export const getShortDate = (date: Date | string) => {
  if (typeof date === "string") {
    const formated = format(new Date(date), "yyyy-MM-dd");
    return formated;
  } else {
    const formated = format(date, "yyyy-MM-dd");
    return formated;
  }
};

export const firstDayMonth = (date) => {
  const start = startOfMonth(new Date(date));
  const formated = format(start, "yyyy-MM-dd") + "T00:00:01.999Z";
  return formated;
};
export const lastDayMonth = (date) => {
  const start = endOfDay(new Date(date));
  const formated = format(start, "yyyy-MM-dd") + "T23:59:59.999Z";
  return formated;
};

export const getLastDayOfMonth = (date) => {
  const [y, m] = [date.getFullYear(), date.getMonth()];
  return new Date(y, m + 1, 0);
};

export const getIndicatorPeriod = (indicator = {}, selectedPeriod = "") => {
  const period = selectedPeriod || get(indicator, `period`, "month");
  let createdAt = get(indicator, `createdAt`, DATA_STATUS_TYPES.DASH);

  const isCreatedAt = createdAt && createdAt !== DATA_STATUS_TYPES.DASH;

  switch (period) {
    case "day":
      createdAt = isCreatedAt
        ? format(new Date(createdAt), "dd MMMM yyyy")
        : DATA_STATUS_TYPES.ND;
      break;
    case "month":
      createdAt = isCreatedAt
        ? format(new Date(createdAt), "MMM yyyy", { locale: ruLocale })
        : DATA_STATUS_TYPES.ND;
      break;
    case "specMonth":
      createdAt = `(${
        isCreatedAt ? format(new Date(createdAt), "MM") : DATA_STATUS_TYPES.ND
      })`;
      break;
    case "quarter":
      createdAt = isCreatedAt
        ? `${getQuarter(new Date(createdAt))}Q ${format(
            new Date(createdAt),
            "yyyy"
          )}`
        : DATA_STATUS_TYPES.ND;
      break;
    case "specQuarter":
      createdAt = isCreatedAt
        ? `(${getQuarter(new Date(createdAt))}Q${format(
            new Date(createdAt),
            "yy"
          )})`
        : `(${DATA_STATUS_TYPES.ND})`;
      break;
    case "year":
      createdAt = isCreatedAt
        ? format(new Date(createdAt), "yyyy")
        : DATA_STATUS_TYPES.ND;
      break;
    case "specYear":
      createdAt = isCreatedAt
        ? format(new Date(createdAt), "yy")
        : DATA_STATUS_TYPES.ND;
      break;
  }
  return createdAt;
};

export const getFormatDate = (date, onlyDate = true) => {
  if (!date) {
    return "";
  }

  if (typeof date === "string") {
    try {
      let rost = format(
        new Date(date),
        onlyDate ? "dd.MM.yyyy" : "dd.MM.yyyy HH:mm:ss"
      );
      return rost;
    } catch (error) {
      console.error("Invalid date string:", date, error);
      return "";
    }
  } else {
    try {
      let rost = format(
        new Date(date),
        onlyDate ? "dd.MM.yyyy" : "dd.MM.yyyy HH:mm:ss"
      );
      return rost;
    } catch (error) {
      console.error("Invalid date object:", date, error);
      return "";
    }
  }
};

export const parseDate = (input: string | null) => {
  const date = parse(input, "dd.MM.yyyy", new Date());

  if (!isValid(date)) {
    return null;
  }

  return format(date, "yyyy-MM-dd");
}
